import { LoggingService } from "../sdServices/loggingSvc";

const dataBiAreaAttribute = "data-bi-area";

// @ngInject
export let fillBiAreaDirective = function (loggingService: LoggingService) {
  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
      let biArea = attrs["sdFillBiArea"];
      if (biArea) {
        element.attr(dataBiAreaAttribute, biArea);
      } else {
        let elementLogText = element.clone().children().remove().end()[0].outerHTML;
        loggingService.logWarning(`Required for telemetry. Enter bi-area for Element: ${elementLogText}`);
      }
    }
  };
};
